<template>
  <el-dialog
    :title="model.id > 0 ? '编辑发票' : '新增发票'"
    :visible.sync="visible"
    width="600px"
    @close="$emit('update:show', false)"
  >
    <el-form
      size="small"
      :model="model"
      :rules="rules"
      ref="form"
      label-width="100px"
    >
      <el-form-item label="" size="small" prop="category" label-width="20px">
        <el-radio v-model="model.category" :label="1" border size="medium"
          >普通发票</el-radio
        >
        <el-radio v-model="model.category" :label="2" border size="medium"
          >增值税专用发票</el-radio
        >
      </el-form-item>
      <template v-if="model.category == 1">
        <el-form-item
          label="发票抬头"
          class="mt-30"
          size="mini"
          prop="letterhead_category"
        >
          <el-radio
            v-model="model.letterhead_category"
            :label="2"
            border
            size="medium"
            >单位</el-radio
          >
          <el-radio
            v-model="model.letterhead_category"
            :label="1"
            border
            size="medium"
            >个人</el-radio
          >
        </el-form-item>
        <el-form-item
          label="个人名称"
          size="small"
          prop="head_name"
          v-if="model.letterhead_category == 1"
        >
          <el-input
            size="small"
            v-model="model.head_name"
            placeholder="请输入个人名称"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="单位名称"
          size="small"
          prop="company_name"
          v-if="model.letterhead_category == 2"
        >
          <el-input
            size="small"
            v-model="model.company_name"
            placeholder="请输入单位名称"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="纳税人识别号"
          size="small"
          prop="tax_number"
          v-if="model.letterhead_category == 2"
        >
          <el-input
            size="small"
            v-model="model.tax_number"
            placeholder="请输入纳税人识别号"
          ></el-input>
        </el-form-item>
        <el-form-item label="发票内容" size="mini" prop="content_type">
          <el-radio v-model="model.content_type" :label="1" border size="medium"
            >商品明细</el-radio
          >
          <el-radio v-model="model.content_type" :label="2" border size="medium"
            >商品类别</el-radio
          >
        </el-form-item>
        <el-form-item label="收票人手机" size="small" prop="contact_phone">
          <el-input
            size="small"
            v-model="model.contact_phone"
            placeholder="请输入手机号"
          ></el-input>
        </el-form-item>
        <el-form-item label="收票人邮箱" size="small" prop="contact_email">
          <el-input
            size="small"
            v-model="model.contact_email"
            placeholder="请输入邮箱"
          ></el-input>
        </el-form-item>
      </template>

      <template v-if="model.category == 2">
        <el-form-item label="单位名称" size="small" prop="company_name">
          <el-input
            size="small"
            v-model="model.company_name"
            placeholder="请输入单位名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="纳税人识别号" size="small" prop="tax_number">
          <el-input
            size="small"
            v-model="model.tax_number"
            placeholder="请输入纳税人识别号"
          ></el-input>
        </el-form-item>

        <el-form-item label="注册地址" size="small" prop="company_address">
          <el-input
            size="small"
            v-model="model.company_address"
            placeholder="请输入注册地址"
          ></el-input>
        </el-form-item>
        <el-form-item label="注册电话" size="small" prop="company_phone">
          <el-input
            size="small"
            v-model="model.company_phone"
            placeholder="请输入注册电话"
          ></el-input>
        </el-form-item>
        <el-form-item label="开户银行" size="small" prop="bank_name">
          <el-input
            size="small"
            v-model="model.bank_name"
            placeholder="请输入开户银行"
          ></el-input>
        </el-form-item>
        <el-form-item label="银行账户" size="small" prop="bank_account">
          <el-input
            size="small"
            v-model="model.bank_account"
            placeholder="请输入银行账户"
          ></el-input>
        </el-form-item>

        <!-- <el-form-item label="发票内容" size="mini" prop="content_type">
          <el-radio v-model="model.content_type" :label="1" border size="medium"
            >商品明细</el-radio
          >
          <el-radio v-model="model.content_type" :label="2" border size="medium"
            >商品类别</el-radio
          >
        </el-form-item> -->

        <!-- <el-form-item label="收票人姓名" size="small" prop="contact_name">
          <el-input
            size="small"
            v-model="model.contact_name"
            placeholder="请输入姓名"
          ></el-input>
        </el-form-item>
        <el-form-item label="收票人手机" size="small" prop="contact_phone">
          <el-input
            size="small"
            v-model="model.contact_phone"
            placeholder="请输入手机号"
          ></el-input>
        </el-form-item>
        <el-form-item label="收票人省份" size="small" prop="area">
          <el-cascader
            style="width: 100%"
            size="small"
            class="long"
            :options="regionData"
            v-model="model.area"
          ></el-cascader>
        </el-form-item>
        <el-form-item
          label="详细地址"
          size="small"
          prop="contact_address_detail"
        >
          <el-input
            size="small"
            v-model="model.contact_address_detail"
            placeholder="请输入详细地址"
          ></el-input>
        </el-form-item> -->
      </template>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">取 消</el-button>
      <el-button size="small" type="primary" @click="submitForm"
        >确 定</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import { createShoppingInvoice, updateShoppingInvoice } from '@/service/getData'
import { regionData } from '@/util/area_tool'
import { clone } from '@/util'

export default {
  props: {
    model: {
      type: Object,
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    show() {
      this.visible = this.show
      if (!this.visible) {
        this.$refs.form.resetFields()
      }
    },
  },
  data() {
    return {
      regionData,
      visible: this.show,
      rules: {},
    }
  },
  methods: {
    submitForm() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          const data = clone(this.model)
          let area = data.area
          if (area.length > 0) {
            data.contact_province = area[0]
          }
          if (area.length > 1) {
            data.contact_city = area[1]
          }
          if (area.length > 2) {
            data.contact_county = area[2]
          }

          if (data.category == 2) {
            data.content_type = 1
          }

          if (data.id > 0) {
            let res = await updateShoppingInvoice(data)
            if (res.code == 0) {
              this.$emit('updated', res.data)
            }
          } else {
            let res = await createShoppingInvoice(data)
            if (res.code == 0) {
              this.$emit('created', res.data)
            }
          }
          this.visible = false
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
  },
}
</script>